<div class="cand-modal modal-info modal-info--red" *ngIf="visibility" [ngClass]="{ 'modal-info--red': specificIconBlock == 'modal-info-red' }">
    <article *ngIf="visibility" [@slideInOut] class="cand-modal__overlay">
        <em class="cand-modal__overlay__close circle-close-icon" (click)="buttonCrossClick()"></em>
        <h1 class="cand-modal__title" [ngClass]="{ modal_bordel_title: specificIconBlock == 'modal-info-red' }">
            {{ modalTitle | i18n }}
        </h1>
        <section class="cand-modal__content modal-info--content">
            <p *ngIf="showInfoIcon" class="iconblock modal-info__iconblock" [ngClass]="{ 'iconblock--red': specificIconBlock == 'modal-info-red' }"></p>
            <p class="modal-info__message" [ngClass]="{ 'hide-icon' : showInfoIcon === false }" [innerHTML]="content | i18n"></p>
            <p *ngIf="complexContent" class="modal-info__message" [innerHTML]="complexContent"></p>
        </section>
        <footer class="cand-modal__footer">
            <p>
                <button *ngIf="showRightButton" class="button button--primary modal-info__next-button ng-binding" (click)="buttonRightClick()">
                    {{ buttonRight | i18n }}
                </button>
                <button *ngIf="showLeftButton" class="button--previous-cancel modal-info__cancel-button ng-binding" (click)="buttonLeftClick()">
                    {{ buttonLeft | i18n }}
                </button>
            </p>
        </footer>
    </article>
    <div class="cand-modal__fade" *ngIf="visibility" [@fadeInOut] (click)="buttonCrossClick()"></div>
</div>
